import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { PiRoadHorizonFill, PiUserCircleFill, PiProjectorScreenFill } from "react-icons/pi";
import { IoCalendar } from "react-icons/io5";
import { MdVerified } from "react-icons/md";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../../../../utils/CapitalizeFirstLetter";
import { CustomDot } from "./components/CustomDots";
import { chunkArray } from "./utils/ChunkArray";
import { StyledTooltip } from "../../../../components/Tooltip";
import { FaCopy } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import { ButtonGroup } from "./components/ButtonGroup";
import { screenMaxWidths } from "./utils/screenWidth";
import { responsive } from "./utils/responsiveConfig";
import { getStatusById } from "./utils/getRouteStatusById";

const RoutesSummaryCarousel = ({ resumeRoutes }) => {
    const screenWidth = window.innerWidth;
    const [routesGroup, setRoutesGroup] = useState([]);
    const [showDots, setShowDots] = useState(true);
    const [copied, setCopied] = useState(false);
    const hiddenButtonRefs = useRef([]);

    useEffect(() => {
        if (resumeRoutes && resumeRoutes.length) {
            let agroupedRoutes = []
            if (screenWidth <= screenMaxWidths.mobile) {
                agroupedRoutes = chunkArray(resumeRoutes, 2)
            } else {
                agroupedRoutes = resumeRoutes.map(r => [r])
            }
            setRoutesGroup(agroupedRoutes)

            const actualResponsive = responsive[Object.keys(responsive).find(key => responsive[key].breakpoint.min <= screenWidth)]
            if (actualResponsive && actualResponsive.items >= agroupedRoutes.length) {
                setShowDots(false)
            }
        }
    }, [resumeRoutes, screenWidth])

    function handleCardClick(routeId) {
        if (routeId) {
            window.open(`/detalhes-rota/${routeId}`, '_blank');
        }
    }

    const handleVisibleButtonClick = (index) => {
        if (hiddenButtonRefs.current[index]) {
            hiddenButtonRefs.current[index].click();
        }
    };

    const handleCopyClick = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }).catch(err => {
            console.error('Erro ao copiar: ', err);
        });
    };

    const handleCardColors = (status) => {
        const statusColors = {
            1: "#6a6a6a",
            2: "#f5cb2b",
            3: "#409E6A"
        }

        if (status in statusColors) return statusColors[status]

        return "#6a6a6a"
    }

    return (
        <div className={styles.main}>
            <div className={styles.carousel}>
                <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={showDots}
                    responsive={responsive}
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={15000}
                    keyBoardControl={true}
                    customTransition="transform 600ms ease-in-out"
                    transitionDuration={1000}
                    containerClass={styles.carouselContainer}
                    removeArrowOnDeviceType={["desktop", "tablet", "mobile", "wideScreen", "superWideScreen"]}
                    customDot={<CustomDot hiddenDotsRef={hiddenButtonRefs} />}
                    customButtonGroup={<ButtonGroup routes={routesGroup} dotsRefs={handleVisibleButtonClick} />}
                >
                    {routesGroup.map(routeGroup =>
                    (<div>
                        {routeGroup.map(routeData => {
                            const driverName = capitalizeFirstLetter(routeData?.driver?.name) ?? ""
                            const status = getStatusById(routeData?.id_route_status)
                            const cardColor = handleCardColors(routeData?.id_route_status)

                            return (
                                <div className={styles.card} style={{ backgroundColor: cardColor }}>
                                    <div className={styles.cardBody}>
                                        <div className={styles.hasAction} onClick={() => handleCardClick(routeData?.id)}>
                                            <PiRoadHorizonFill style={{ color: cardColor }} />
                                            <strong>ROTA:</strong>
                                            <span>{routeData?.id}</span>
                                        </div>
                                        <div>
                                            <MdVerified style={{ color: cardColor }} />
                                            <strong>OBJETOS ENTREGUES:</strong>
                                            <span> {routeData?.objectsDelivered} de {routeData?.routeShipping?.length}</span>
                                        </div>
                                        <div>
                                            <IoCalendar style={{ color: cardColor }} />
                                            <strong>DATA CRIAÇÃO:</strong>
                                            <span>{moment(routeData?.created_at).format("DD/MM/YYYY")}</span>
                                        </div>
                                        <div>
                                            <PiUserCircleFill size={23} style={{ color: cardColor }} />
                                            <strong>MOTORISTA:</strong>
                                            <StyledTooltip
                                                text={
                                                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                                        {driverName}
                                                        {copied ?
                                                            <FaCheckCircle
                                                                style={{ color: "#409E6A", cursor: "pointer" }}
                                                            />
                                                            : <FaCopy
                                                                style={{ color: "#409E6A", cursor: "pointer" }}
                                                                onClick={() => handleCopyClick(driverName)}
                                                            />}
                                                    </div>
                                                }
                                                position="top"
                                                arrow
                                            >
                                                <span> {driverName}</span>
                                            </StyledTooltip>
                                        </div>
                                        <div>
                                            <PiProjectorScreenFill style={{ color: cardColor }} />
                                            <strong>STATUS:</strong>
                                            <span>{capitalizeFirstLetter(`Rota ${status}`)}</span>
                                        </div>
                                    </div>
                                </div>)
                        })}
                    </div>))}
                </Carousel>
            </div>

        </div >
    );
};

export { RoutesSummaryCarousel };
